import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  style: {"background":"#F8F8FF"},
  class: "sm:h-115px h-16 flex items-center justify-center"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev" }, null, -1)

import { onMounted, ref } from 'vue'
import { Autoplay, Navigation } from 'swiper'
import { Swiper } from 'swiper/vue/swiper'
import { SwiperSlide } from 'swiper/vue/swiper-slide'
import { ProjectSide } from '@/libs/types'

export default /*#__PURE__*/_defineComponent({
  props: {
    windowWidth: null
  },
  setup(__props: any) {


const projectSideList:ProjectSide[] = [
  {
    logo_src: '4everland',
    href: 'https://www.4everland.org/'
  },
  {
    logo_src: 'akord',
    href: 'https://akord.com/',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-70'
  }, {
    logo_src: 'arconnect',
    href: 'https://www.arconnect.io/',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-85'
  }, {
    logo_src: 'ar_news',
    href: 'https://arweave.news/',
    imgOpacity: 'opacity-85'
  }, {
    logo_src: 'bitkeep',
    href: 'https://bitkeep.com/'
  }, {
    logo_src: 'conflux',
    href: 'https://confluxnetwork.org/zh',
    imgOpacity: 'opacity-65'
  }, {
    logo_src: 'decentland',
    href: 'https://www.decent.land/',
    styleOpacity: 'opacity-85'
  }, {
    logo_src: 'ethsign',
    href: 'https://www.ethsign.xyz/'
  }, {
    logo_src: 'knn3',
    href: 'https://www.knn3.xyz/',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-65'
  }, {
    logo_src: 'metaforo',
    href: 'https://metaforo.io/',
    imgOpacity: 'opacity-65'
  }, {
    logo_src: 'meson_network',
    href: 'https://meson.network/'
  }, {
    logo_src: 'moonbeam',
    href: 'https://moonbeam.network/'
  }, {
    logo_src: 'pianity',
    href: 'https://pianity.com/',
    styleOpacity: 'opacity-90',
    imgOpacity: 'opacity-55'
  }, {
    logo_src: 'platon',
    href: 'https://www.platon.network/en',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-65'
  }, {
    logo_src: 'quest3',
    href: 'https://quest3.xyz/',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-55'
  }, {
    logo_src: 'readon',
    href: 'https://readon.me/#/'
  }, {
    logo_src: 'redstone',
    href: 'https://redstone.finance/'
  }, {
    logo_src: 'relation',
    href: 'https://relationlabs.ai/#/home',
    imgOpacity: 'opacity-65'
  }, {
    logo_src: 'safeheron',
    href: 'https://www.safeheron.com/',
    styleOpacity: 'opacity-85'
  }, {
    logo_src: 'show_me',
    href: 'https://showme.fan/',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-55'
  }, {
    logo_src: 'warp',
    href: 'https://warp.cc/',
    styleOpacity: 'opacity-90',
    imgOpacity: 'opacity-65'
  },
  {
    logo_src: 'echo',
    href: 'https://0xecho.com/',
    styleOpacity: 'opacity-90',
    imgOpacity: 'opacity-100'
  }

]
const swiperEl = ref<any>(null)
const onSwiper = (swiper:any) => {
  console.log(swiper)
  swiperEl.value = swiper
}
const onSlideChange = () => {
  console.log('slide change')
}
const mouseover = () => {
  if (swiperEl.value?.autoplay) {
    swiperEl.value?.autoplay?.stop()
  }
}
const mouseleave = () => {
  if (swiperEl.value?.autoplay) {
    swiperEl.value?.autoplay?.start()
  }
}
onMounted(() => {
  const dom = document.querySelector('.mySwiper')
  dom?.addEventListener('mousemove', () => {
    mouseover()
  })
  dom?.addEventListener('mouseout', () => {
    mouseleave()
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Swiper), {
      modules: [_unref(Autoplay),_unref(Navigation)],
      class: "mySwiper",
      "slides-per-view": "auto",
      loop: true,
      speed: 2500,
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      onSwiper: onSwiper,
      onSlideChange: onSlideChange
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(projectSideList, (item, index) => {
          return _createVNode(_unref(SwiperSlide), {
            key: index,
            class: "projectSidestyle"
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                class: _normalizeClass(["flex md:h-8 h-5 justify-center items-center", item.styleOpacity ? item.styleOpacity : '']),
                style: {"width":"109px"},
                href: item.href,
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: require(`@/images/${item.logo_src}${item.logo_src === 'arconnect' ? '.svg' : '.png'}`),
                  class: _normalizeClass(["h-full transition-opacity", item.imgOpacity ? item.imgOpacity : '']),
                  alt: item.logo_src
                }, null, 10, _hoisted_3)
              ], 10, _hoisted_2)
            ]),
            _: 2
          }, 1024)
        }), 64)),
        _hoisted_4,
        _hoisted_5
      ]),
      _: 1
    }, 8, ["modules", "navigation"])
  ]))
}
}

})